import React from 'react';
import './QuotePage.css';
import API from '../API';
import Footer from '../components/Footer';
import GoogleMapReact from 'google-map-react';
import NavBar from '../components/NavBar';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import {phone as PhoneChecker} from 'phone';
import QuoteMapComponent from '../components/QuoteMapComponent';


var downloadDivRef = undefined;
const pricings =[
    {
        name: "Motorsiklet",
        image: require("../assets/vehicles/araclar-13.svg").default,
        sizeLimit: "35 x 25 x 12 cm",
        weight: 5
    },{
        name: "Sedan",
        image: require("../assets/vehicles/araclar-16.svg").default,
        sizeLimit:"70 x 50 x 50 cm",
        weight: 500
    },{
        name: "Doblo",
        image: require("../assets/vehicles/araclar-10.svg").default,
        sizeLimit:"1.8 x 1.5 x 1.2 m",
        weight: 500
    },{
        name: "Minivan",
        image: require("../assets/vehicles/araclar-14.svg").default,
        sizeLimit:"2.1 x 1.7 x 1.2 m",
        weight: 1000
    },{
        name: "Panelvan",
        image: require("../assets/vehicles/araclar-09.svg").default,
        sizeLimit:"3 x 1.5 x 1.5 m",
        weight: 2500
    },{
        name: "Kamyonet",
        image: require("../assets/vehicles/araclar-15.svg").default,
        sizeLimit:"4.2 x 2 x 2 m",
        weight: 2500
    }
]
const rnd = (len, chars='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => [...Array(len)].map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('')


var session = "";
const WorldMarker = ({ text }) => <div><svg style={{marginLeft:-25, marginTop:-25}} width="50" height="50" viewBox="0 0 50 50"><g fill="none"><path fill="#3c9cd7" d="M12.585 21.336l-.585.512-.585-.512C6.499 17.034 4 13.286 4 10a8 8 0 1 1 16 0c0 3.286-2.499 7.034-7.415 11.336z"></path><path fill="#FFF" d="M12 7.444c1.655 0 3 1.348 3 3.002a3.002 3.002 0 0 1-3 2.998c-1.655 0-3-1.347-3-3a3.002 3.002 0 0 1 3-3z"></path></g></svg></div>;
export default class QuotePage extends React.Component {

    constructor() {
        super();
        this.waypoints = [undefined, undefined];
        this.state = {focused:false, formLoading: false,phone:"", formStep: 0,loading:false, center: {lat: 41.015,lng:28.979}}
        this.oldcalculate = undefined;
//,pricing: [10,10,10,10,10,10]
        session = rnd(36);
    }

    render() {
        return <div><NavBar /><div style={{display:"flex", flex:1,flexDirection:"column"}}>

            <div style={{display:"flex", paddingTop:70}}>
            
                <div style={{flex:1,display:"flex",flexWrap:"wrap-reverse"}}>
                    <div style={{display:"flex", flex:1,minWidth:300, alignItems:"center",flexDirection:"column",justifyContent:"center"}}>
                        <div className='pricingDiv' style={{height: 470}}>
                            {this.state.formLoading && <div style={{display:"flex", flex:1,height:"100%",justifyContent:"center", alignItems:"center"}}>
                            
      <div className="loading-spinner-big">
      
    </div>
                                </div>}
                    {this.state.formStep == 0 && !this.state.formLoading && <div style={{height:window.innerHeight*.45}}><p style={{fontSize:24,fontWeight:"600"}}>{this.alreadyCalculated==true?"Yeni":"Hemen"} fiyatlandırma oluştur</p>
                    <p style={{marginTop:15}}>Daha fazla nokta mı lazım? <a href='https://tasimacim.app' target={"_blank"} onClick={() => {
                    
                }} style={{color:"#3c9cd7"}}>Uygulamayı indir</a></p>
                    <WaypointInput onSelectedWaypoint={(x) => this.onSelectedWaypoint(0,x)} id={0} onBlur={() => {focused = false; this.setState({focused:false}) }} onFocus={() => this.onWaypointFocus(0)} placeholder="Bir alış noktası girin" title='Nereden' />
                    <WaypointInput onSelectedWaypoint={(x) => this.onSelectedWaypoint(1,x)} id={1} onBlur={() => {focused = false; this.setState({focused:false}) }} onFocus={() => this.onWaypointFocus(1)} placeholder="Bir teslimat noktası girin" title='Nereye'/>

                    <button onClick={() => {
                        if(!this.waypoints[0] || !this.waypoints[1] || this.state.loading) return;

                        if(JSON.stringify(this.waypoints) == this.oldcalculate) return;


                       this.oldcalculate = JSON.stringify(this.waypoints);
                    //    this.setState({loading: true});
                    //     API.fetch("calculate",{waypoints:this.waypoints}).then((e) => {

                           
                    //         this.setState({pricing: e, loading: false});
                            
                    //     })

                        this.setState({formLoading: true});

                        setTimeout(() => {
                            this.setState({formLoading: false, formStep: 1});
                        }, 2000);
                    }} className='estimateFee'>Devam Et</button></div>}


{this.state.formStep == 1 && !this.state.formLoading && <div style={{height:window.innerHeight*.45,paddingLeft:20, paddingRight:20}}><p style={{fontSize:24,fontWeight:"600"}}>Fiyatlandırman hazır!</p>

<p style={{marginTop:25}}>Size özel fiyatlandırmanızı saklamamız için lütfen telefon numaranızı girin</p>

<PhoneInput
  country={'tr'}
  value={this.state.phone}
  onChange={phone => {
    this.setState({ phone })
    console.log(phone);
  }}
  containerStyle={{marginTop:30}}
/>
                    
                    {/* <input className='telInput' value={this.state.text} onChange={(v) => {
            
            this.setState({text: v.target.value, loading: true})
            const val = v.target.value;
            this.props.onSelectedWaypoint(undefined);


            if(this.autocompleteQuery) clearTimeout(this.autocompleteQuery);
            
            if(val.trim() == "" || val.length <= 2) {

                this.autocompleteQuery = undefined;
                this.setState({autocomplete: [], loading: false})
                return;
            }
            this.autocompleteQuery = setTimeout(() => {
                var txt = val;
                API.fetchClient("autocomplete",{q: txt, session}).then((e) => {

                    console.log(e);
                   
                    if(this.state.text == txt) this.setState({autocomplete: e, loading: false});
                })

                
            }, 300);
        }} onBlur={() => {
            setTimeout(() => {
                this.props.onBlur()
            }, 100);
            
        
        }} onFocus={() => this.props.onFocus()} placeholder={this.props.placeholder} type={'text'}  /> */}


<p style={{marginTop:25}}>Bu aşamayı atlamak için <a href='https://tasimacim.app' target={"_blank"} onClick={() => {
                    // window.scrollTo(0,0);
                    // window.scrollTo({top:10000, behavior:"smooth"})
                    
                }} style={{color:"#3c9cd7"}}>Uygulamayı indir</a></p>
                    <button onClick={() => {

                        const v = PhoneChecker("+"+this.state.phone);
                        if(!v.isValid) return; 
                       
                        this.setState({formLoading: true});
                    //     if(!this.waypoints[0] || !this.waypoints[1] || this.state.loading) return;

                    //     if(JSON.stringify(this.waypoints) == this.oldcalculate) return;


                    //    this.oldcalculate = JSON.stringify(this.waypoints);
                    //    this.setState({loading: true});
                        API.fetch("calculate",{waypoints:this.waypoints,phone: v.phoneNumber}).then((e) => {

                            console.log(e);
                            this.calculated = true;
                            this.alreadyCalculated = true;
                            
                            this.setState({pricing: e, formLoading:false, formStep:0});
                            
                        })

                        

                        
                    }} className='estimateFee' style={{marginTop:100,marginLeft:0}}>Fiyatlandırmayı Gör</button></div>}
                    </div>
                    </div>
                    {<div style={{display:"flex", flex:1}}>
                    
                    <div style={{height:"100%",width:"100%",minWidth:300,minHeight:200}}>

                        <QuoteMapComponent ref={a => this.googleMap = a} />
                    


                    </div>
                    </div>}
                </div>


            

            </div>
        {this.state.pricing && <div ref={(a) => {
            if(this.calculated && a) {
                this.calculated = false;
                a.scrollIntoView( { behavior: 'smooth', block: 'start' } );
            }
        }} style={{marginTop:0,scrollMarginTop: 50, backgroundColor:"#F7F8F8", paddingTop:60,marginBottom:20, paddingBottom:50,flex:1,alignItems:"center",display:"flex", flexDirection:"column"}}>
                <p id='pricingTextScroll' className='pricingTextScroll' style={{fontSize:25, textAlign:"center"}}>Fiyatlandırmanız</p>

                <div className='pricingParentDiv' style={{maxWidth:800, display:"flex", flexWrap:"wrap",justifyContent:"center"}}>
                {pricings.map((x, i) => i == 1 || i == 3?<></>:<QuoteVehicle discount={pricingDiscounts[i]} key={i} img={x.image} title={x.name} dimen={x.sizeLimit} weight={x.weight} loading={this.state.loading} price={this.state.pricing[i]} />)}
                </div>

                {/* <p className='pricingTextScroll' style={{fontSize:25, textAlign:"center",marginTop:20}}>Taşımacım uygulamasını hemen indir</p> */}
                <div style={{display:"flex", paddingLeft:"5%", paddingRight:"5%",flexDirection:"column"}}>
                <p className='pricingTextScroll' ref={a => codeDivRef = a} style={{fontSize:35,scrollMarginTop:90, textAlign:"center",marginTop:35,color:"#3C9CD7"}}>HSGLDN25</p>
                <p className='pricingTextScroll' style={{fontSize:25, textAlign:"center",marginTop:15}}>Kodu ile ilk siparişinde 25₺'ye varan indirim kazan</p>
                <p className='pricingTextScroll' style={{fontSize:14, textAlign:"center",marginTop:15, color:"gray"}}>*Kampanya 3 Ekim tarihine kadar kartla yapılan siparişlerde geçerlidir</p>
                </div>
            </div>}


            <div ref={(a) => {
                downloadDivRef = a;
            }} style={{display:"flex",scrollMarginTop:140,flex:1, flexDirection:"column", alignItems:"center",marginTop:35,paddingLeft:30,paddingRight:30}}>

                <p style={{fontSize:24, textAlign:"center",fontWeight:"600"}}>Taşımacım uygulamasını indir.</p>
                <p style={{fontSize:17, textAlign:"center",fontWeight:"300", marginTop:10}}>Tek elle eşyalarını istediğin her yerde taşıt.</p>

                {window.innerWidth <= 768 && <a href='https://tasimacim.app/web' target={"_blank"}><img style={{maxWidth:300, marginTop:20, marginBottom:20}}  src={require('../assets/download.png')} /></a>}
                {window.innerWidth > 768 && <img style={{maxWidth:300,width:200, marginTop:20, marginBottom:35}}  src={require('../assets/download.png')} />}
            </div>

            <Footer />
        </div></div>

        
    }
    onSelectedWaypoint(id,waypoint) {
        

        if(!waypoint) return;

        window.scrollTo({ top: 0, behavior: 'smooth' });

        API.fetchClient("autocompleteendsession", {session, _id: waypoint.place}).then((waypoint) => {
            this.waypoints[id] = waypoint;


            if(waypoint) {
                if(this.waypoints[0] && this.waypoints[1]) {
                    this.setState({center: {lat: (this.waypoints[0].Point[1]+this.waypoints[1].Point[1])/2, lng: (this.waypoints[0].Point[0]+this.waypoints[1].Point[0])/2}})

                    this.googleMap.updateMarkers(this.waypoints, {lat: (this.waypoints[0].Point[1]+this.waypoints[1].Point[1])/2, lng: (this.waypoints[0].Point[0]+this.waypoints[1].Point[0])/2});
                } else {
                    this.setState({center: {lat: waypoint.Point[1], lng: waypoint.Point[0]}})
                    this.googleMap.updateMarkers(this.waypoints, {lat: waypoint.Point[1], lng: waypoint.Point[0]});
                }
                console.log(this.waypoints);
                
            }
        });
        
        session = rnd(36);
        

        
            

        
    }
    onWaypointFocus(id) {
        
        latestFocus = id;
        this.state.focused = true;
        focused = true;

        this.forceUpdate();
    }
}

var latestFocus;
var focused = false;
var codeDivRef = undefined;

const pricingDiscounts = [50,50,75,75,100,125];

const QuoteVehicle = (props) => 

(window.innerWidth <= 768)?
<div onClick={() => {
    codeDivRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
    //downloadDivRef.scrollIntoView({ behavior: 'smooth', block: 'center' })
}} style={{display:"flex",boxShadow:"0px 0px 4px #cccccc", flex:1,borderRadius:15,backgroundColor:"white",marginTop:20,padding:15}}>
    <div style={{display:"flex",flex:1}}>
<img style={{height:60}} src={props.img} />

    <div style={{marginLeft:"5%"}}>
        <p style={{fontWeight:"bold", fontSize:20}}>{props.title}</p>
        <p style={{color:"gray",fontSize:13, marginTop:5}}>Yük: {props.dimen}</p>
        <p style={{color:"gray",fontSize:13, marginTop:5}}>Ağırlık: {props.weight} kg</p>
    </div>
    </div>
    <div><p style={{fontWeight:"bold",color:"crimson", textDecoration:"line-through",fontSize:13,textAlign:"center"}}>{props.price}₺</p><p style={{fontWeight:"bold",fontSize:16}}>{props.price-props.discount}₺</p></div>
</div>
:
<div style={{alignItems:"center",width:250, display:"flex", flexDirection:"column", marginTop:60}}>
    <img style={{height:80}} src={props.img} />
    <p style={{marginTop:20,fontSize:14,fontWeight:"600"}}>{props.title}</p>
    <p style={{marginTop:15, color:"rgb(0, 18, 26)",fontSize:14}}>{props.dimen}</p>
    {!props.loading && <p style={{marginTop:20, fontSize:16,color:"crimson", textDecoration:"line-through"}}>{props.price}₺</p>}
    {!props.loading && <p style={{marginTop:5, fontSize:22}}>{props.price-props.discount}₺</p>}
    {props.loading && <div className="spinner-container">
      <div className="loading-spinner">
      </div>
    </div>}
</div>

class WaypointInput extends React.Component {


    constructor() {
        super();

        this.state = {text: "",autocomplete: [], loading: false};
        
    }

    //768px
    render() {
        return <div style={{marginTop:40,display:"flex", position:"relative"}} className='waypointInput'>
        <svg width="24" height="24" viewBox="0 0 24 24"><g fill="none"><path fill="#3c9cd7" d="M12.585 21.336l-.585.512-.585-.512C6.499 17.034 4 13.286 4 10a8 8 0 1 1 16 0c0 3.286-2.499 7.034-7.415 11.336z"></path><path fill="#FFF" d="M12 7.444c1.655 0 3 1.348 3 3.002a3.002 3.002 0 0 1-3 2.998c-1.655 0-3-1.347-3-3a3.002 3.002 0 0 1 3-3z"></path></g></svg>
        <div style={{width:"100%", marginLeft:20}}>
        <p>{this.props.title}</p>
        <div style={{alignItems:"center",display:"flex"}}>
        <input value={this.state.text} onChange={(v) => {
            
            this.setState({text: v.target.value, loading: true})
            const val = v.target.value;
            this.props.onSelectedWaypoint(undefined);


            if(this.autocompleteQuery) clearTimeout(this.autocompleteQuery);
            
            if(val.trim() == "" || val.length <= 2) {

                this.autocompleteQuery = undefined;
                this.setState({autocomplete: [], loading: false})
                return;
            }
            this.autocompleteQuery = setTimeout(() => {
                var txt = val;
                API.fetchClient("autocomplete",{q: txt, session}).then((e) => {

                    
                   
                    if(this.state.text == txt) this.setState({autocomplete: e, loading: false});
                })

                
            }, 300);
        }} onBlur={() => {
            setTimeout(() => {
                this.props.onBlur()
            }, 100);
            
        
        }} onFocus={() => this.props.onFocus()} placeholder={this.props.placeholder} type={'text'}  />

            {this.state.loading && <div style={{position:"absolute", right: 10,marginBottom:2}}>

            <div className="spinner-container">
      <div className="loading-spinner">
      </div>
    </div>
            </div>}
        </div>
        {latestFocus == this.props.id && focused && this.state.autocomplete.length > 0 && 
        <div className="autocompleteStart">
            
           
            {this.state.autocomplete.map((x, i) =>  <div onClick={() => {
                this.props.onSelectedWaypoint(x);
                this.setState({text: x.Label});
            }} className='autocompleteKey' key={i}>
                <p>{x.Label}</p>
            </div>
        )}
            </div>}
        {/* // <div style={{position:"absolute", bottom: -15, width:"100%",backgroundColor:"white", borderRadius:2, boxShadow:"0px 0px 3px 0px #000000", justifyContent:"flex-end", alignContent:"flex-end"}}>
        //     <p>TEST PARAGRAPH</p>
        //     <p>TEST PARAGRAPH</p>
        // </div> */}
        </div>
        
    </div>
    }
}